import { Injectable } from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {ErrorArgument} from '../../../shared/models/interfaces/errorArgument.interface';
import Swal from 'sweetalert2';
import {CONFIG} from '../../../config';
import {Diagram} from 'gojs';
import {EmapsError} from '../../../shared/models/interfaces/emapsError.interface';

@Injectable()
export class MindMapErrorService {

  constructor() { }

  public mindMapError(error: EmapsError, diagram?: Diagram) {
    switch (error.code) {
      case CONFIG.errors.mindMapVersionNodeUpdateErrorCode:
        this.defaultErrorModal(error);
        this.showNodeError(error, diagram);
        break;
      default:
        this.defaultErrorModal(error);
    }
  }

  private defaultErrorModal(error: EmapsError) {
    Swal.fire({
      title: 'Error Saving Map',
      html: `<div style="white-space: pre-wrap">${this.getSaveErrorMessage(error)}</div>`,
      footer: `<div class="px-3">Error code ${error.code}: ${error.message}</div>`,
      buttonsStyling: false,
      showConfirmButton: true,
      confirmButtonText: 'OK',
      customClass: {
        confirmButton: 'btn btn-secondary',
      },
    });
  }

  // tslint:disable:max-line-length
  private getSaveErrorMessage(error: EmapsError): string {
    let message = `Something went wrong when saving the map.
    WARNING: If you continue working or refresh the browser, you may lose progress.
    Please try to save the map again manually. If the error persists, contact the eMaps team at <a href="mailto:${CONFIG.contactEmail}">${CONFIG.contactEmail}</a>.`;

    if (!error) {
      return message;
    }

    const errArgValue = error.arguments ? error.arguments.find(arg => arg.key === 'value') : null;
    let value = 'undefined';
    if (errArgValue) {
      value = errArgValue.value;
    }
    switch (error.code) {
      case CONFIG.errors.milestoneCategoryValueMissingErrorCode:
        message = `The milestone value "${value}" is invalid.
        Please try again, and if this error persists contact the eMaps team at <a href="mailto:${CONFIG.contactEmail}">${CONFIG.contactEmail}</a>.`;
        break;
      case CONFIG.errors.invalidMilestoneDateFormatErrorCode:
        message = `The date "${value}" is in an invalid format.`;
        break;
    }

    return message;
  }

  private showNodeError(error: EmapsError, diagram: Diagram) {
    if (error.code === CONFIG.errors.mindMapVersionNodeUpdateErrorCode) {
      const errorData = error.arguments;
      if (errorData) {
        const keyArg = errorData.find(arg => arg.key === 'key');
        if (keyArg) {
          /* Attempt to find the node by key, but if unable (e.g. the node is newly created and gets assigned a new key by the backend)
           * use the location and content to find the node
           */
          let node = diagram.findNodeForKey(keyArg.value);
          if (!node) {
            const loc = errorData.find(arg => arg.key === 'loc').value.replace(/\.0(?!\d)/g, '');
            const text = errorData.find(arg => arg.key === 'text').value;
            const matchingNodes = diagram.findNodesByExample({loc: loc, text: text});
            if (matchingNodes.next()) {
              node = matchingNodes.value;
            }
          }

          if (node) {
            diagram.model.setDataProperty(node.data, 'isError', true);
            diagram.model.setDataProperty(node.data, 'errorMessage', 'Unable to save node');
          }
        }
      }
    }
  }
}
